document.addEventListener('variant:change', function(event) {
  const variant = event.detail.variant;
  const button = document.querySelector('.klaviyo-bis-trigger');

  if (!button || !variant) return;

  if (variant.available) {
    button.style.display = 'none';
  } else {
    button.style.display = '';
  }
});
document.addEventListener('variant:change', function(event) {
  const variant = event.detail.variant;

  if (variant && !variant.available) {
    document.body.classList.add('show-out-of-stock');
  }
});

document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector(':checked + .block-swatch.is-disabled')) {
    document.body.classList.add('show-out-of-stock');
  }
});
function moveBackInStockButton() {
  document.querySelectorAll('.klaviyo-bis-trigger').forEach((bisButton) => {
    const scope =
      bisButton.closest('form') ||
      bisButton.closest('product-info') ||
      document;

    const buyButtons = scope.querySelector('buy-buttons');

    if (!buyButtons) return;

    const parent = buyButtons.parentElement;

    // Only move it if it isn't already directly above the buy buttons
    if (buyButtons.previousElementSibling !== bisButton) {
      parent.insertBefore(bisButton, buyButtons);
    }
  });
}

// Run once after page load
document.addEventListener('DOMContentLoaded', () => {
  moveBackInStockButton();
});

// Klaviyo and Shopify can re-render after variant changes,
// so watch for changes and put it back in the correct position.
const bisObserver = new MutationObserver(() => {
  moveBackInStockButton();
});

bisObserver.observe(document.body, {
  childList: true,
  subtree: true
});
/* =========================================================
   34ERS - MULTILINGUAL KLAVIYO BACK IN STOCK SYSTEM
   ========================================================= */

(() => {

  const shownVariants = new Set();

  let currentVariantAvailable = null;
  let observerScheduled = false;


  /* =========================================================
     LANGUAGE
     ========================================================= */

  function getLanguage() {

    const firstPathPart =
      window.location.pathname
        .split('/')
        .filter(Boolean)[0]
        ?.toLowerCase() || 'en';


    if (
      firstPathPart === 'fr' ||
      firstPathPart.startsWith('fr-')
    ) {
      return 'fr';
    }


    if (
      firstPathPart === 'de' ||
      firstPathPart.startsWith('de-')
    ) {
      return 'de';
    }


    if (
      firstPathPart === 'da' ||
      firstPathPart.startsWith('da-')
    ) {
      return 'da';
    }


    return 'en';
  }


  const translations = {

    en: {
      heading:
        'This size is currently sold out',

      paragraphOne:
        "We're sorry — this size is currently out of stock. This product has been extremely popular and we're working to get more stock available as soon as possible.",

      paragraphTwo:
        "Sign up to be the first to know when it's back in stock.",

      button:
        'Notify Me When Back In Stock',

      close:
        'Close'
    },


    fr: {
      heading:
        'Cette taille est actuellement épuisée',

      paragraphOne:
        "Nous sommes désolés — cette taille est actuellement en rupture de stock. Ce produit a rencontré un immense succès et nous faisons notre maximum pour le réapprovisionner dès que possible.",

      paragraphTwo:
        "Inscrivez-vous pour être parmi les premiers informés de son retour en stock.",

      button:
        'Prévenez-moi dès son retour en stock',

      close:
        'Fermer'
    },


    de: {
      heading:
        'Diese Größe ist derzeit ausverkauft',

      paragraphOne:
        "Es tut uns leid — diese Größe ist derzeit nicht auf Lager. Dieses Produkt ist äußerst beliebt und wir arbeiten daran, so schnell wie möglich Nachschub zu bekommen.",

      paragraphTwo:
        "Melden Sie sich an, um als Erstes zu erfahren, sobald es wieder auf Lager ist.",

      button:
        'Benachrichtigen, sobald wieder verfügbar',

      close:
        'Schließen'
    },


    da: {
      heading:
        'Denne størrelse er i øjeblikket udsolgt',

      paragraphOne:
        "Vi beklager — denne størrelse er i øjeblikket udsolgt. Produktet har været meget populært, og vi arbejder på at få det på lager igen så hurtigt som muligt.",

      paragraphTwo:
        "Tilmeld dig for at få besked som en af de første, når det er tilbage på lager.",

      button:
        'Giv mig besked, når den er tilbage på lager',

      close:
        'Luk'
    }

  };


  const language =
    getLanguage();


  const text =
    translations[language] ||
    translations.en;


  /* =========================================================
     KLAVIYO ELEMENTS
     ========================================================= */

  function getKlaviyoContainer() {

    return document.querySelector(
      '#klaviyo-bis-button-container'
    );

  }


  function getKlaviyoButton() {

    const container =
      getKlaviyoContainer();


    if (!container) {
      return null;
    }


    return (
      container.querySelector(
        'button[data-a11y-identifier^="bis-button-"]'
      ) ||
      container.querySelector('button')
    );

  }


  /* =========================================================
     TRANSLATE NORMAL PAGE KLAVIYO BUTTON
     ========================================================= */

  function updateKlaviyoButtonText() {

    const button =
      getKlaviyoButton();


    if (!button) {
      return;
    }


    if (
      button.textContent.trim() !== text.button
    ) {

      button.textContent =
        text.button;

    }

  }


  /* =========================================================
     SHOW / HIDE NORMAL KLAVIYO BUTTON
     ========================================================= */

  function updateKlaviyoVisibility() {

    const container =
      getKlaviyoContainer();


    if (!container) {
      return;
    }


    updateKlaviyoButtonText();


    /*
      IN STOCK
    */

    if (
      currentVariantAvailable === true
    ) {

      container.classList.add(
        'bis-force-hide'
      );

      return;

    }


    /*
      SOLD OUT
    */

    if (
      currentVariantAvailable === false
    ) {

      container.classList.remove(
        'bis-force-hide'
      );

    }

  }


  /* =========================================================
     CREATE POPUP
     ========================================================= */

  function buildSoldOutPopup() {

    if (
      document.getElementById(
        'sold-out-popup'
      )
    ) {
      return;
    }


    const popup =
      document.createElement('div');


    popup.id =
      'sold-out-popup';


    popup.hidden =
      true;


    popup.innerHTML = `

      <div class="sold-out-popup__overlay"></div>

      <div
        class="sold-out-popup__content"
        role="dialog"
        aria-modal="true"
        aria-labelledby="sold-out-popup-title"
      >

        <button
          type="button"
          class="sold-out-popup__close"
          aria-label="${text.close}"
        >
          ×
        </button>

        <h2 id="sold-out-popup-title">
          ${text.heading}
        </h2>

        <p>
          ${text.paragraphOne}
        </p>

        <p>
          ${text.paragraphTwo}
        </p>

        <button
          type="button"
          class="sold-out-popup__notify"
        >
          ${text.button}
        </button>

      </div>

    `;


    document.body.appendChild(
      popup
    );


    /* CLOSE */

    popup
      .querySelector(
        '.sold-out-popup__close'
      )
      .addEventListener(
        'click',
        closeSoldOutPopup
      );


    /* BACKGROUND */

    popup
      .querySelector(
        '.sold-out-popup__overlay'
      )
      .addEventListener(
        'click',
        closeSoldOutPopup
      );


    /* POPUP NOTIFY BUTTON */

    popup
      .querySelector(
        '.sold-out-popup__notify'
      )
      .addEventListener(
        'click',
        openRealKlaviyoForm
      );


    /* ESC */

    document.addEventListener(
      'keydown',
      (event) => {

        if (
          event.key === 'Escape' &&
          !popup.hidden
        ) {

          closeSoldOutPopup();

        }

      }
    );

  }


  /* =========================================================
     OPEN REAL KLAVIYO FORM
     ========================================================= */

  function openRealKlaviyoForm(attempt = 0) {

    const realButton =
      getKlaviyoButton();


    /*
      Klaviyo may still be rebuilding after
      the selected variant changes.
    */

    if (!realButton) {

      if (
        attempt < 20
      ) {

        setTimeout(() => {

          openRealKlaviyoForm(
            attempt + 1
          );

        }, 100);

      }


      return;
    }


    closeSoldOutPopup();


    setTimeout(() => {

      realButton.click();

    }, 120);

  }


  /* =========================================================
     OPEN EXPLANATION POPUP
     ========================================================= */

  function openSoldOutPopup() {

    buildSoldOutPopup();


    const popup =
      document.getElementById(
        'sold-out-popup'
      );


    if (!popup) {
      return;
    }


    popup.hidden =
      false;


    document.body.classList.add(
      'sold-out-popup-open'
    );


    setTimeout(() => {

      popup
        .querySelector(
          '.sold-out-popup__close'
        )
        ?.focus();

    }, 50);

  }


  /* =========================================================
     CLOSE EXPLANATION POPUP
     ========================================================= */

  function closeSoldOutPopup() {

    const popup =
      document.getElementById(
        'sold-out-popup'
      );


    if (!popup) {
      return;
    }


    popup.hidden =
      true;


    document.body.classList.remove(
      'sold-out-popup-open'
    );

  }


  /* =========================================================
     DETECT INITIAL AVAILABILITY
     ========================================================= */

  function detectInitialAvailability() {

    const buttons =
      Array.from(
        document.querySelectorAll(
          'buy-buttons button[type="submit"]'
        )
      );


    const buyButton =
      buttons.find((button) => {

        return (
          button.offsetParent !== null
        );

      }) || buttons[0];


    if (!buyButton) {
      return;
    }


    const buttonText =
      buyButton.textContent
        .trim()
        .toLowerCase();


    const soldOut =
      buyButton.disabled &&
      (
        buttonText.includes('sold out') ||
        buttonText.includes('unavailable') ||
        buttonText.includes('épuis') ||
        buttonText.includes('rupture') ||
        buttonText.includes('ausverkauft') ||
        buttonText.includes('nicht verfügbar') ||
        buttonText.includes('udsolgt')
      );


    currentVariantAvailable =
      !soldOut;


    updateKlaviyoVisibility();

  }


  /* =========================================================
     PRESTIGE VARIANT CHANGE
     ========================================================= */

  function handleVariantChange(event) {

    const variant =
      event.detail?.variant;


    if (!variant) {
      return;
    }


    currentVariantAvailable =
      variant.available !== false;


    /* IN STOCK */

    if (
      currentVariantAvailable
    ) {

      closeSoldOutPopup();


      setTimeout(() => {

        updateKlaviyoVisibility();

      }, 100);


      return;
    }


    /* SOLD OUT */

    setTimeout(() => {

      updateKlaviyoVisibility();

    }, 150);


    const variantId =
      String(variant.id);


    /*
      Show automatically only once per
      sold-out variant during this page visit.
    */

    if (
      shownVariants.has(
        variantId
      )
    ) {

      return;

    }


    shownVariants.add(
      variantId
    );


    setTimeout(() => {

      openSoldOutPopup();

    }, 200);

  }


  /* =========================================================
     WATCH KLAVIYO
     ========================================================= */

  function startKlaviyoObserver() {

    const observer =
      new MutationObserver(() => {

        if (
          observerScheduled
        ) {
          return;
        }


        observerScheduled =
          true;


        requestAnimationFrame(() => {

          updateKlaviyoVisibility();

          updateKlaviyoButtonText();


          observerScheduled =
            false;

        });

      });


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }


  /* =========================================================
     INITIALISE
     ========================================================= */

  function initialiseBackInStock() {

    buildSoldOutPopup();


    document.addEventListener(
      'variant:change',
      handleVariantChange
    );


    startKlaviyoObserver();


    setTimeout(() => {

      detectInitialAvailability();

      updateKlaviyoButtonText();

    }, 300);


    setTimeout(() => {

      detectInitialAvailability();

      updateKlaviyoButtonText();

    }, 800);


    setTimeout(() => {

      updateKlaviyoVisibility();

      updateKlaviyoButtonText();

    }, 1500);

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialiseBackInStock
    );

  } else {

    initialiseBackInStock();

  }

})();